export default "__VITE_ASSET__y$8V4$Qg__"